import Vue from 'vue'
import Vuex from 'vuex'
import teacher from './modules/teacher'
import menu from './modules/menu'
import global from './modules/user'
import currency from './modules/currency'
import i18n from '../language/i18n'
import myEn from '../language/myEn'
import myZhCN from '../language/myZh'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(Vuex)

/**
 * Vuex全局状态管理
 * @param options {Array} 用于渲染tabs的数组
 */
const store = new Vuex.Store({
  state: {
    options: [],
    activeIndex: '/',
    userInfo: {},
    flightList: [],
    reloadingFlight: false,
    airportList: [],
    companyList: [],
    companyType: ''
  },
  mutations: {
    // 添加tabs
    add_tabs (state, data) {
      this.state.options.push(data)
    },
    // 删除tabs
    delete_tabs (state, route) {
      let index = 0
      for (let option of state.options) {
        if (option.route === route) {
          break
        }
        index++
      }
      this.state.options.splice(index, 1)
    },
    // 设置当前激活的tab
    set_active_index (state, index) {
      this.state.activeIndex = index
    },
    // 设置详情信息
    save_detail_info (state, info) {
      this.state.userInfo = info
    },
    // 获取航司列表
    set_flightList(state, info) {
      state.flightList = info
    },
    // 获取机场列表
    set_airportList(state, info) {
      state.airportList = info
    },
    set_reloadingFlight(state, info) {
      state.reloadingFlight = info
    },
    // 获取商户列表
    set_compantList: (state, data) => {
      state.companyList = data;
    },
    set_companyType: (state, data) => {
      state.companyType = data
    }
  },
  actions: {
    fetchFlightData({ commit }) {
      let flightzh = {}
      let flighten = {}
      let currAcct = {}
      if (localStorage.getItem('currAcct')) {
        currAcct = JSON.parse(localStorage.getItem('currAcct'))
      }
      Vue.prototype.$http.post('/inp/mis/zsAirline/getBySql.htm', {
        loginType: currAcct.aType
      }).then(response => {
        const result = response.data ? response.data.result : []
        commit('set_flightList', result);
        result.forEach(item => {
          flightzh[item.airlineName] = item.airlineName
          flighten[item.airlineName] = item.airlineCodeEnglishName
        })
        i18n.setLocaleMessage('zhCN', Object.assign(zhLocale, { ...myZhCN, ...flightzh }));
        i18n.setLocaleMessage('en',Object.assign(enLocale, {...myEn, ...flighten}));
        }).catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    fetchAirportData({ commit }) {
      let zh = {}
      let en = {}
      let currAcct = {}
      if (localStorage.getItem('currAcct')) {
        currAcct = JSON.parse(localStorage.getItem('currAcct'))
      }
      Vue.prototype.$http.post('/inp/mis/zsAirport/getBySql.htm', {
        loginType: currAcct.aType
      }).then(response => {
        const result = response.data ? response.data.result : []
        commit('set_airportList', result);
        result.forEach(item => {
          zh[item.airportName] = item.airportName
          if (item.airportEnglishName) {
            en[item.airportName] = item.airportEnglishName
          }
          zh[item.cityName] = item.cityName
          if (item.cityEnglishName) {
            en[item.cityName] = item.cityEnglishName
          }
        })
        i18n.setLocaleMessage('zhCN', Object.assign(zhLocale, { ...myZhCN, ...zh }));
        i18n.setLocaleMessage('en',Object.assign(enLocale, {...myEn, ...en}));
        }).catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    GetCompanyList({ commit }) {
      let currAcct = {}
      if (localStorage.getItem('currAcct')) {
        currAcct = JSON.parse(localStorage.getItem('currAcct'))
      }
      if (currAcct.aType === 1) {
        let parameter = {
          loginType: currAcct.aType,
          companyId: 0
        }
        Vue.prototype.$http.post('/inp/mis/company/getCache.htm', parameter).then(function (response) {
          let resBoby = response.data
          if (resBoby.code === 0) {
            let companylist = resBoby.result || []
            commit("set_compantList", companylist);
          }
        })
      }
    },
  },
  modules: {
    teacher,
    menu,
    global,
    currency
  },
  getters: {
    companyList: (state) => state.companyList,
    companyType: (state) => state.companyType,
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js